module.exports = __webpack_public_path__ + "img/3-2-IMG_3001.9bbdb2d1.png";